import { render, staticRenderFns } from "./Parallax1.vue?vue&type=template&id=b83fb388&scoped=true&"
import script from "./Parallax1.ts?vue&type=script&lang=ts&"
export * from "./Parallax1.ts?vue&type=script&lang=ts&"
import style0 from "./Parallax1.vue?vue&type=style&index=0&id=b83fb388&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b83fb388",
  null
  
)

export default component.exports